// @flow

import * as React from 'react';

type Props = {
  width?: string,
  height?: string,
  color?: string,
};

export const Phone = ({ width, height, color }: Props) => (
  <svg
    viewBox="0 0 20 20"
    width={width || '100%'}
    height={height || '100%'}
    style={{ fill: color || 'currentColor' }}
  >
    <path d="M14.936 20c-.985 0-1.97-.373-2.72-1.123L1.126 7.785c-1.5-1.5-1.5-3.94 0-5.44l2.197-2.2c.195-.194.51-.194.705 0l4.218 4.22c.195.194.195.51 0 .703L6.886 6.43l6.678 6.68 1.36-1.362c.196-.194.51-.194.705 0l4.225 4.226c.194.194.194.508 0 .704l-2.198 2.2c-.75.75-1.736 1.122-2.72 1.122zM3.676 1.202L1.83 3.05c-.54.537-.835 1.253-.835 2.014 0 .762.295 1.478.834 2.017l11.16 11.162c1.11 1.11 2.85 1.04 3.963-.07l1.845-1.847-3.52-3.52-1.362 1.36c-.187.188-.518.188-.704 0L5.83 6.783c-.196-.194-.196-.51 0-.704l1.36-1.36L3.676 1.2z" />
  </svg>
);
